import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/9-marketplaces-like-depop';

export default function Example() {
  return (
    <>
      <Head>
        <title>9 Marketplaces Like Depop - 2022</title>
        <meta
          name='description'
          content='Depop is the most used app for online selling. And with the whole e-commerce world keeping up with the trend, many other marketplace competitors are picking up with their popularity. Find out here what other fashion resale sites are out there where you can list your items and reach more potential buyers.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/9-marketplaces-like-depop' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/9-marketplaces-like-depop' />
        <meta property='og:title' content='9 Marketplaces Like Depop - 2022' />
        <meta
          property='og:description'
          content='Depop is the most used app for online selling. And with the whole e-commerce world keeping up with the trend, many other marketplace competitors are picking up with their popularity. Find out here what other fashion resale sites are out there where you can list your items and reach more potential buyers.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
